import axiosInstance from "../api";

export const registerUser = async (data) => {
  try {
    const response = axiosInstance.post("auth/register", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const loginWithSocial = async (data) => {

  try {
    const response = await axiosInstance.post("auth/social", data);
    console.log(response, 'Response from social backend api');
    return response
  } catch (error) {
    throw error;
  }
};

export const loginWithPassword = async (data) => {
  try {
    const response = await axiosInstance.post("auth/login", data);
    return response
  } catch (error) {
    throw error;
  }
};

export const sendOTP = async (data) => {
  try {
    const response = await axiosInstance.post("auth/send-otp", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const loginVerifyOTP = async (data) => {
  try {
    const response = await axiosInstance.post("auth/login/verify-otp", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const checkMobile = async (data) => {
  try {
    const response = await axiosInstance.post("auth/check-mobile", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const onlyVerifyOTP = async (data) => {
  try {
    const response = await axiosInstance.post("auth/verify-otp", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const logOutUser = async () => {
  try {
    const response = await axiosInstance.get("auth/logout");
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUserDetails = async () => {
  try {
    const response = await axiosInstance.get("auth/get-profile");
    return response;
  } catch (error) {
    throw error;
  }
};

export const upDateUserDetails = async (data) => {
  try {
    const response = await axiosInstance.post("auth/update-profile", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    const response = axiosInstance.post("auth/change-password", data);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getRefreshToken = async (data) => {
  try {
    const response = await axiosInstance.post("auth/refresh-token", data);
    return response;
  } catch (error) {
    throw error;
  }
};
